import { TabBar } from '@components/TabBar';
import { TabControl } from '@components/TabControl';
import { TabPage } from '@components/TagPage';
import { IData } from '@hooks/useData';
import { ILoading } from '@hooks/useLoading';
import { useTab } from '@hooks/useTab';
import { makeStyles, Tab } from '@material-ui/core';
import ILinha from '@model/Linha';
import { IRelatorioStatusLinhaFilter } from '@services/RelatorioService';
import React from 'react';
import { RelatorioStatusLinhaTable } from './Table';

enum EnumPages {
    Cliente = 0,
    Funcionario = 1,
    SemContrato = 2
}

export type RelatorioStatusLinhaTabsProps = {
    clienteData: IData<ILinha, IRelatorioStatusLinhaFilter>
    funcionarioData: IData<ILinha, IRelatorioStatusLinhaFilter>
    semContratoData: IData<ILinha, IRelatorioStatusLinhaFilter>

    clienteLoading: ILoading
    funcionarioLoading: ILoading
    semContratoLoading: ILoading

    handleClienteCsv: VoidFunction
    handleFuncionarioCsv: VoidFunction
    handleSemContratoCsv: VoidFunction
}

export function RelatorioStatusLinhaTabs ({clienteData, funcionarioData, semContratoData, clienteLoading, funcionarioLoading, semContratoLoading, handleClienteCsv, handleFuncionarioCsv, handleSemContratoCsv}: RelatorioStatusLinhaTabsProps) {
    const cls = useStyles();
    const tab = useTab();

    return (
        <React.Fragment>
            <TabBar className={cls.root}>
                <TabControl tab={tab}>
                    <Tab label="Com Cliente" value={EnumPages.Cliente}></Tab>
                    <Tab label="Com Funcionário" value={EnumPages.Funcionario}></Tab>
                    <Tab label="Sem Contrato" value={EnumPages.SemContrato}></Tab>
                </TabControl>
            </TabBar>
        
            <TabPage index={EnumPages.Cliente} tabIndex={tab.tabIndex}>
                <RelatorioStatusLinhaTable
                    data={clienteData}
                    isLoading={clienteLoading.isLoading}
                    onCsvButtonClick={handleClienteCsv}
                />            
            </TabPage>

            <TabPage index={EnumPages.Funcionario} tabIndex={tab.tabIndex}>
                <RelatorioStatusLinhaTable
                    data={funcionarioData}
                    isLoading={funcionarioLoading.isLoading}
                    onCsvButtonClick={handleFuncionarioCsv}
                />            
            </TabPage>

            <TabPage index={EnumPages.SemContrato} tabIndex={tab.tabIndex}>
                <RelatorioStatusLinhaTable
                    data={semContratoData}
                    isLoading={semContratoLoading.isLoading}
                    onCsvButtonClick={handleSemContratoCsv}
                />            
            </TabPage>

        </React.Fragment>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(2)
    }
}))